import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { HomeService } from './home.service';
import { AuthService } from '../auth.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {

  counters: any = {};
  oshaDigits: string[] = ['0', '0', '0', '0'];
  vehicleDigits: string[] = ['0', '0', '0', '0'];
  oshaBest: number = 0;
  vehicleBest: number = 0;
  isAuthorized: boolean = false;
  isAxisAuthorized: boolean = false;
  axisReconciling: boolean = false;
  employeeId: number;
  authorizedIDs: number[] = [185, 24, 226, 130, 151, 73, 1, 3, 39, 206];
  axisAuthorizedIDs: number[] = [151, 185, 130];

  constructor(
    public auth: AuthService,
    public homeService: HomeService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.auth.userProfile$.subscribe((profile) => {
      if (profile) {
        this.employeeId = this.auth.getEmployeeId();
        this.isAuthorized = this.authorizedIDs.includes(this.employeeId);
        this.isAxisAuthorized = this.axisAuthorizedIDs.includes(this.employeeId);
      }
    });

    this.loadCounters();
  }

  ngOnDestroy(): void {}

  loadCounters(): void {
    this.homeService.getSafetyCounters().subscribe(
      (res) => {
        if (!res.Error && res.Counters) {
          res.Counters.forEach((c) => {
            if (c.incident_type === 'osha') {
              this.oshaDigits = this.toDigits(c.days_without_incident);
              this.oshaBest = c.highest_days_without_incident;
            } else if (c.incident_type === 'vehicle') {
              this.vehicleDigits = this.toDigits(c.days_without_incident);
              this.vehicleBest = c.highest_days_without_incident;
            }
          });
        }
      },
      (err) => console.log(err)
    );
  }

  toDigits(num: number): string[] {
    let s = String(num).padStart(4, '0');
    if (s.length > 4) s = s.slice(-4);
    return s.split('');
  }

  resetCounter(type: string): void {
    console.log('Reset button pressed - employeeId:', this.employeeId, 'isAuthorized:', this.isAuthorized);
    const dialogRef = this.dialog.open(ResetCounterDialogComponent, {
      width: '400px',
      data: { incident_type: type }
    });

    dialogRef.afterClosed().subscribe((reason) => {
      if (reason) {
        this.homeService.resetSafetyCounter(type, reason, this.employeeId).subscribe(
          (res) => {
            console.log(res);
            this.loadCounters()
          },
          (err) => console.log(err)
        );
      }
    });
  }

  adjustCounter(type: string, direction: string): void {
    this.homeService.adjustSafetyCounter(type, direction, this.employeeId).subscribe(
      () => this.loadCounters(),
      (err) => console.log(err)
    );
  }

  runAxisReconcile(): void {
    this.axisReconciling = true;
    this.homeService.runAxisReconcile().subscribe(
      (res) => {
        this.axisReconciling = false;
        const tab = window.open('', '_blank');
        if (tab) {
          tab.document.write('<pre>' + JSON.stringify(res, null, 2) + '</pre>');
          tab.document.title = 'AXIS Reconciliation Results';
          tab.document.close();
        }
      },
      (err) => {
        this.axisReconciling = false;
        console.error('AXIS reconcile error:', err);
        alert('AXIS reconciliation failed. Check console for details.');
      }
    );
  }
}

@Component({
  selector: 'app-reset-counter-dialog',
  template: `
    <h2 mat-dialog-title>Report Incident</h2>
    <mat-dialog-content>
      <p>This will reset the <strong>{{ data.incident_type === 'osha' ? 'OSHA Recordable' : 'Vehicle Accident' }}</strong> counter to 0.</p>
      <mat-form-field style="width: 100%">
        <mat-label>Reason for reset</mat-label>
        <textarea matInput [(ngModel)]="reason" rows="3" placeholder="Describe the incident..."></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button mat-raised-button color="warn" [disabled]="!reason || !reason.trim()" (click)="dialogRef.close(reason)">Reset Counter</button>
    </mat-dialog-actions>
  `
})
export class ResetCounterDialogComponent {
  reason: string = '';

  constructor(
    public dialogRef: MatDialogRef<ResetCounterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
